import React, { useCallback, useEffect, useState } from 'react';
import { searchFieldCss } from './utils';
import { Icon } from '../Icon';
import './SearchField.scss';
export const SearchField = ({ placeholder = 'Search', onSearch = () => { }, delay = 300, className, overrideCss, }) => {
    const { searchField, searchFieldCleanButton, searchFieldInput, searchFieldSearchIcon, } = searchFieldCss({ className, overrideCss });
    const [input, setInput] = useState();
    const triggerSearch = useCallback(() => {
        if (input && input !== '') {
            onSearch(input);
            return;
        }
        onSearch(undefined);
    }, [input, onSearch]);
    const handleClear = () => {
        setInput('');
        if (onSearch) {
            onSearch(undefined);
        }
    };
    const handleEnter = (e) => {
        e.preventDefault();
        triggerSearch();
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            triggerSearch();
        }, delay);
        return () => clearTimeout(timer);
    }, [delay, input, onSearch, triggerSearch]);
    return (React.createElement("form", { onSubmit: handleEnter, className: searchField },
        React.createElement("div", { className: searchFieldSearchIcon },
            React.createElement(Icon, { source: "Search" })),
        React.createElement("input", { className: searchFieldInput, type: "search", placeholder: placeholder, value: input, onChange: (e) => setInput(e.target.value) }),
        input && (React.createElement("button", { className: searchFieldCleanButton, type: "button", onClick: handleClear },
            React.createElement(Icon, { source: "Clear" })))));
};
//# sourceMappingURL=SearchField.js.map